import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import Shimmer from 'react-native-shimmer';

import { machineStatusColorName } from './functions';
import { WALLBOARD_PROGRESS_BAR } from '@components/wallboard/constants';

import HourBlock from './hourBlock';

const ProgressBar = ({ scale, C, tileWidth, font, machineStatus, machineId, timeLine, localTime, style, lineHeight = 6 }) => {
  const historyHeight = lineHeight;

  const hourLength = tileWidth * WALLBOARD_PROGRESS_BAR.HOUR_LENGTH_RATIO;

  const events = timeLine?.[machineId] || [];
  const { status } = machineStatus;

  const secondWidth = hourLength / 3600;

  return (
    <View
      style={[
        {
          width: '100%',
          height: WALLBOARD_PROGRESS_BAR.HEIGHT_PERCENT,
          paddingHorizontal: WALLBOARD_PROGRESS_BAR.PADDING_HORIZONTAL_PERCENT,
          paddingTop: WALLBOARD_PROGRESS_BAR.PADDING_TOP_PERCENT,
          overflow: 'hidden',
        },
        style,
      ]}
    >
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          paddingRight: (Number(localTime().format('mm')) * hourLength) / 60,
        }}
      >
        <HourBlock {...{ moment: localTime().subtract(4, 'h'), scale, C, historyHeight, hourLength, font }} />
        <HourBlock {...{ moment: localTime().subtract(3, 'h'), scale, C, historyHeight, hourLength, font }} />
        <HourBlock {...{ moment: localTime().subtract(2, 'h'), scale, C, historyHeight, hourLength, font }} />
        <HourBlock {...{ moment: localTime().subtract(1, 'h'), scale, C, historyHeight, hourLength, font }} />
        <HourBlock {...{ moment: localTime(), scale, C, historyHeight, hourLength, font }} />
      </View>
      <View
        style={{
          width: '100%',
          height: historyHeight,
          borderRadius: historyHeight / 2,
          overflow: 'hidden',
          justifyContent: 'flex-end',
          whiteSpace: 'nowrap',
          flexDirection: 'row',
        }}
      >
        {events.length ? (
          events.map((i, index) => {
            const isLast = events.length - 1 == index;
            const duration = isLast ? moment.utc().diff(moment.utc(i.startedOn), 'seconds') : i.durationInSeconds;

            if (isLast && i.status !== status) {
              return [
                <View
                  key={`${i.startedOn}-${i.endedOn}-${machineId}-last`}
                  style={{ width: i.durationInSeconds * secondWidth, height: '100%', backgroundColor: C(machineStatusColorName[i.status]) }}
                />,
                <View
                  key={`${i.startedOn}-${i.endedOn}-${machineId}-last-status`}
                  style={{
                    width: moment.utc().diff(moment.utc(i.endedOn), 'seconds') * secondWidth,
                    height: '100%',
                    backgroundColor: C(machineStatusColorName[status]),
                  }}
                />,
              ];
            }

            return (
              <View
                key={`${i.startedOn}-${i.endedOn}-${machineId}`}
                style={{ width: duration * secondWidth, height: '100%', backgroundColor: C(machineStatusColorName[i.status]) }}
              />
            );
          })
        ) : (
          <Shimmer>
            <View
              style={{
                width: scale(500),
                height: historyHeight,
                backgroundColor: C('Gray/Light/3'),
              }}
            />
          </Shimmer>
        )}
      </View>
    </View>
  );
};

export default ProgressBar;
